export default {
  or: {
    en: 'or',
  },
}
